// "productUpdate" -> "Product update", "labelsPrinted" -> "Labels printed".
export const humanizeAction = (action: string): string => {
  const words = action
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .toLowerCase()
    .trim();

  return words.charAt(0).toUpperCase() + words.slice(1);
};

// "Product:42" -> "Product #42"
export const describeTarget = (target: string): string => {
  const [type, id] = target.split(":");

  return id ? `${type} #${id}` : target;
};
